import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import OnboardingFlowContainer from './OnboardingFlow';
import rootReducer from '../../../reducers';
var store = createStore(rootReducer);
function OnboardingFlow(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(OnboardingFlowContainer, props));
}
export default OnboardingFlow;